import { 
  replaceSubstitutes,
  requestStart,
  requestFailure,
  requestEnd, 
} from "../bomSlice"

import { searchSubstitutes } from "pu-actions/bomQuote"
import { selectDataForPartSearch } from "../selector/selectors"

export const searchPossibleSubstitutes = (bom_line_item_id, keyword) => async (dispatch, getState) => {
  dispatch(requestStart())

  const {board_qtys} = selectDataForPartSearch(getState())
  
  let quote_number = ''
  let quote_status = ''
  let offers = []

  do {
    try {
      const response = await searchSubstitutes(bom_line_item_id, keyword, quote_number, board_qtys)
      const quote_data = response.result
      quote_number = quote_data.quote_number
      quote_status = quote_data.quote_status
      offers = quote_data.offers
    } catch (err) {
      if(quote_status !== 'quoting'){
        console.log(err)
        dispatch(requestFailure(`Couldn't get Substitutes for Item`))
        return
      }
    }
    if(quote_status !== 'quoted') await new Promise(resolve => setTimeout(resolve, 2000))
  } while(quote_status !== 'quoted')

  dispatch(replaceSubstitutes({ offers }))
  dispatch(requestEnd())
}